import { render, staticRenderFns } from "./template3.vue?vue&type=template&id=4c0c5af4&scoped=true"
import script from "./template3.vue?vue&type=script&lang=js"
export * from "./template3.vue?vue&type=script&lang=js"
import style0 from "./template3.vue?vue&type=style&index=0&id=4c0c5af4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c5af4",
  null
  
)

export default component.exports